import { BigNumber } from "ethers";
import { parseValue } from "lib/numbers";

export const ZERO_BIGNUMBER = BigNumber.from(0);
export const ONE_BIGNUMBER = parseValue("1", 30)!;
